module.exports = __webpack_public_path__ + "media/images/applicant/polygon-white-f54aceb68465bd2de736d1acdbf81fb4.svg";